/* Dipesh Chaudhari - Personal Portfolio Configuration */

// Website related settings
const settings = {
  isSplash: false,
};

// SEO Related settings
const seo = {
  title: "Dipesh's Portfolio",
  description:
    "A results-driven Software Developer with 4+ years of experience designing and building scalable enterprise applications with .NET Core, ASP.NET MVC, Web API, microservices, AWS, SQL Server, PostgreSQL, Redis, RabbitMQ, and secure API architectures.",
  og: {
    title: "Dipesh Chaudhari Portfolio",
    type: "website",
    url: "https://dipeshchaudhari3255.github.io/",
  },
};

// Home Page
const greeting = {
  title: "Dipesh Chaudhari",
  logo_name: "DipeshChaudhari",
  nickname: "DC",
  subTitle:
    "Software Developer with 4+ years of experience designing and building scalable enterprise applications, with a strong focus on backend systems, microservices, clean architecture, RESTful API design, AWS cloud deployments, and secure .NET solutions.",
  resumeLink:
    "https://drive.google.com/file/d/1qpA6hNQg8LMCc96BUW3zt1zCwGOsGDhr/view?usp=drive_link",
  portfolio_repository: "https://github.com/dipeshchaudhari3255/",
  githubProfile: "https://github.com/dipeshchaudhari3255/",
};

// Social Media Links
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/dipeshchaudhari3255",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/dipeshchaudhari2105/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:dipeshchaudhari3255@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "X-Twitter",
    link: "https://x.com/Dipesh_arun",
    fontAwesomeIcon: "fa-x-twitter",
    backgroundColor: "#000000",
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/dipesh.chaudhari.908650/",
    fontAwesomeIcon: "fa-facebook-f",
    backgroundColor: "#1877F2",
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/dipesh.chaudhari2105/",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
];

// Skills
const skills = {
  data: [
    {
      title: ".NET & Backend Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing and building scalable enterprise backend systems using ASP.NET Core, MVC, Web API, Entity Framework Core, Dapper, and middleware",
        "⚡ Developing secure RESTful APIs and microservices with clean architecture, repository patterns, API versioning, JWT authentication, role-based authorization, and VAPT remediation",
        "⚡ Integrating Redis, RabbitMQ, and Hangfire for caching, asynchronous messaging, and background job processing",
        "⚡ Optimizing SQL Server, PostgreSQL, and MySQL stored procedures, indexes, and queries for high-volume data processing",
      ],
      softwareSkills: [
        {
          skillName: "C#",
          fontAwesomeClassname: "simple-icons:csharp",
          style: { color: "#239120" },
        },
        {
          skillName: ".NET Core",
          fontAwesomeClassname: "simple-icons:dotnet",
          style: { color: "#512BD4" },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: { color: "#336791" },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: { color: "#DC382D" },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "simple-icons:rabbitmq",
          style: { color: "#FF6600" },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: { color: "#F1502F" },
        },
        {
          skillName: "SQL Server",
          fontAwesomeClassname: "simple-icons:microsoftsqlserver",
          style: { color: "#CC2927" }
        },
        {
          skillName: "JWT",
          fontAwesomeClassname: "simple-icons:jsonwebtokens",
          style: { color: "#000000" }
        },
        {
          skillName: "Microservices",
          fontAwesomeClassname: "simple-icons:microdotblog",
          style: { color: "#5C2D91" }
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#2496ED" }
        },
        {
          skillName: "Dapper",
          fontAwesomeClassname: "simple-icons:dapper",
          style: { color: "#512BD4" }
        },
        {
          skillName: "Entity Framework Core",
          fontAwesomeClassname: "simple-icons:dotnet",
          style: { color: "#512BD4" }
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: { color: "#4479A1" }
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" }
        },
        {
          skillName: "Hangfire",
          fontAwesomeClassname: "simple-icons:hangfire",
          style: { color: "#FF6600" }
        },
        {
          skillName: "Clean Architecture"
        },
        {
          skillName: "System Design"
        },
        {
          skillName: "Agile Methodologies"
        }
      ],
    },
    {
      title: "Frontend Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Developing dynamic and user-friendly frontends using jQuery, Kendo UI, HTML, CSS, and JavaScript",
        "⚡ Creating responsive interfaces that integrate cleanly with ASP.NET MVC and REST APIs",
        "⚡ Collaborating closely with backend services for secure, reliable user experiences",
      ],
      softwareSkills: [
        {
          skillName: "Kendo UI",
          fontAwesomeClassname: "simple-icons:jquery",
          style: { color: "#0769AD" },
        },
        {
          skillName: "Vuexy Template",
          fontAwesomeClassname: "simple-icons:jquery",
          style: { color: "#0769AD" },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: { color: "#0769AD" },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: { color: "#7952B3" },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: { color: "#1572B6" },
        },
      ],
    },
  ],
};

// Competitive Sites
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: { color: "#F79F1B" },
      profileLink: "https://leetcode.com/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: { color: "#2EC866" },
      profileLink: "https://www.hackerrank.com/",
    },
  ],
};

// Education
const degrees = {
  degrees: [
    {
      title: "Sardar Patel University",
      subtitle: "Master of Computer Application (MCA)",
      logo_path: "spu_logo.jfif",
      alt_name: "Sardar Patel University",
      duration: "2020 - 2022",
      descriptions: [
        "⚡ Specialized in software development and full-stack web technologies.",
        "⚡ Built academic projects focused on enterprise systems using .NET Core and SQL.",
      ],
      website_link: "https://spuvvn.edu/",
    },
    {
      title: "Veer Narmad South Gujarat University",
      subtitle: "Bachelor of Computer Application (BCA)",
      logo_path: "vnsgu_logo.png",
      alt_name: "Veer Narmad South Gujarat University",
      duration: "2017 - 2020",
      descriptions: [
        "⚡ Learned foundational computer science, databases, and programming concepts.",
        "⚡ Developed web-based applications and participated in academic tech projects.",
      ],
      website_link: "https://vnsgu.ac.in/",
    },
  ],
};

// Certifications
const certifications = {
  certifications: [
    {
      title: "Learning C#",
      subtitle: "- LinkedIn Learning",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/015cf6758e096518483da265db47eeec0e90ad185b02f4b39a8807a8aa14816e",
      alt_name: "LinkedIn",
      color_code: "#0077B5",
    },
    {
      title: "SQL Practice: Intermediate Queries",
      subtitle: "- LinkedIn Learning",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/370ff87624be578e12f8981e44d8adf745ce89ed17db13755ad41147d65844f1",
      alt_name: "LinkedIn",
      color_code: "#0077B5",
    },
    {
      title: "Building Web APIs with ASP.NET Core 8",
      subtitle: "- LinkedIn Learning",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/7ca351b331e16f366ef2403ba5eaa8e3766081b9da672b28d6f93958752da771",
      alt_name: "LinkedIn",
      color_code: "#0077B5",
    },
    {
      title: "Learning ASP.NET Core MVC",
      subtitle: "- LinkedIn Learning",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/5ce48cdb9db7afd5203ff1ab34a8d36e20c34821b6ca298ab08317cf380fe83d",
      alt_name: "LinkedIn",
      color_code: "#0077B5",
    },
  ],
};

// Experience
const experience = {
  title: "Experience",
  subtitle: "Professional Work Experience",
  description:
    "I have {{##yearsOfExperience##}}+ years of experience designing and building scalable enterprise applications with a strong focus on backend systems. My work spans .NET Core, ASP.NET MVC, Web API, microservices, clean architecture, AWS cloud deployment, CI/CD automation, SQL optimization, Redis, RabbitMQ, Hangfire, JWT-based authentication, role-based authorization, and API security remediation.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      work: true,
      experiences: [
       {
          title: "Software Developer",
          company: "Microvista Technologies Pvt. Ltd.",
          company_url: "https://www.microvistatech.com/",
          logo_path: "microvista_logo.png",
          duration: "Feb 2025 – Present",
          location: "Ahmedabad, Gujarat",
          description: "Working on GST platforms, vendor verification systems, subscription and billing modules, support applications, and supporting infrastructure. Designed scalable REST APIs using .NET Core, SQL Server, and PostgreSQL; implemented JWT authentication, role-based authorization, API rate limiting, Redis caching, Hangfire background jobs, and query optimizations for high-volume processing. Built and automated AWS deployment infrastructure using ECS, ECR, CodePipeline, CodeBuild, Lambda, CloudWatch, RDS, WAF, Route53, IAM, S3, Docker, Serilog, Elasticsearch, Kibana, and Cloudflare Tunnel, while contributing to VAPT-driven security fixes.",
          color: "#0170BD",
        },
        {
          title: "Software Engineer",
          company: "Casepoint Pvt. Ltd.",
          company_url: "https://www.casepoint.com/",
          logo_path: "casepoint_logo.png",
          duration: "May 2022 – Dec 2024",
          location: "Surat, Gujarat",
          description:
            "Designed and implemented scalable legal hold systems and FOIA portals for federal agencies to improve transparency, submission tracking, and document processing. Built secure REST APIs for data processing and compliance workflows, integrated RabbitMQ for asynchronous processing, optimized PostgreSQL queries, and used Redis caching to improve performance and reliability.",
          color: "#0170BD",
        },
        {
          title: "Intern",
          company: "Casepoint Pvt. Ltd.",
          company_url: "https://www.casepoint.com/",
          logo_path: "casepoint_logo.png",
          duration: "Jan 2022 – Apr 2022",
          location: "Surat, Gujarat",
          description:
            "Built an internal asset tracking system using .NET Core Web API and PostgreSQL. Implemented Redis caching to improve system responsiveness and reduced page load time by 20% through backend performance optimization.",
          color: "#0170BD",
        },
      ],
    },
  ],
};

// Notable Achievements
const achievementSection = {
  title: "Notable Achievements",
  subtitle: "Recognition for delivery excellence and impact",
  achivementsCards: [
    {
      title: "Sprint Delivery Stud",
      subtitle:
        "Awarded in October 2023 for delivering the highest number of story points with the fewest bugs among team members over two quarters.",
      image: "achievement.svg",
      footerLink: [
        { name: "Casepoint", url: "https://www.casepoint.com/" },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Here are some of my highlighted enterprise projects across GST compliance, vendor verification, support systems, legal hold, and FOIA portals, built with .NET Core, ASP.NET MVC, Web API, SQL Server, PostgreSQL, Redis, RabbitMQ, Hangfire, AWS, Docker, Clean Architecture, and Microservices.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
  {
      name: "GST Platform",
      description:
        "Developed enterprise GST compliance platforms, including E-Way Bill API integrations, subscription and billing workflows, scalable REST APIs, secure authentication, rate limiting, Redis caching, Hangfire jobs, and automated AWS CI/CD deployments.",
      languages: [
        { name: ".NET Core", iconifyClass: "simple-icons:dotnet" },
        { name: "MySQL", iconifyClass: "simple-icons:mysql" },
        { name: "PostgreSQL", iconifyClass: "simple-icons:postgresql" },
        { name: "API Gateway", iconifyClass: "simple-icons:microsoft" },
        { name: "Microservices", iconifyClass: "simple-icons:microsoft" },
        { name: "Hangfire", iconifyClass: "simple-icons:microsoft" },
        { name: "AWS", iconifyClass: "simple-icons:microsoft" },
        { name: "Dapper", iconifyClass: "simple-icons:microsoft" },
      ],
      link: "https://crm.gsp.microvistatech.com/",
    },
    {
      name: "Vendor Verification System",
      description: "Built a production-ready vendor verification system that automates PAN, GSTIN, DIN/CIN, bank, and e-invoice/IRN checks through modular .NET microservices, reusable helper libraries, secure REST APIs, and background job processing.",
      languages: [
        { name: ".NET Core", iconifyClass: "simple-icons:dotnet" },
        { name: "MySQL", iconifyClass: "simple-icons:mysql" },
        { name: "API Gateway", iconifyClass: "simple-icons:microsoft" },
        { name: "Microservices", iconifyClass: "simple-icons:microsoft" },
        { name: "Hangfire", iconifyClass: "simple-icons:hangfire" },
        { name: "AWS", iconifyClass: "simple-icons:amazonaws" },
        { name: "Dapper", iconifyClass: "simple-icons:dapper" },
      ],
      link: "https://kyc.microvistatech.com/",
    },
    {
      name: "Legal Hold System & FOIA Portal",
      description:
        "Designed scalable legal hold and FOIA portal backends for large ESI datasets, with secure REST APIs, compliance workflows, automated notifications and escalations, RabbitMQ asynchronous processing, Redis caching, and PostgreSQL query optimization.",
      languages: [
        { name: ".NET Core", iconifyClass: "simple-icons:dotnet" },
        { name: "PostgreSQL", iconifyClass: "simple-icons:postgresql" },
        { name: "Kendo UI", iconifyClass: "simple-icons:jquery" },
        { name: "Redis", iconifyClass: "simple-icons:redis" },
        { name: "RabbitMQ", iconifyClass: "simple-icons:rabbitmq" },
        { name: "Git", iconifyClass: "simple-icons:git" },
      ],
      link: "https://www.casepoint.com/",
    },
    {
      name: "Support Application",
      description: "Developed a full-stack ASP.NET Core support and call-logging system with REST APIs, EF Core, SQL Server, JWT authentication, attachments, comments, role-based access, performance optimizations, and support workflow management.",
      languages: [
        { name: ".NET Core", iconifyClass: "simple-icons:dotnet" },
        { name: "MySQL", iconifyClass: "simple-icons:mysql" },
        { name: "API Gateway", iconifyClass: "simple-icons:microsoft" },
        { name: "Microservices", iconifyClass: "simple-icons:microsoft" },
        { name: "Hangfire", iconifyClass: "simple-icons:hangfire" },
        { name: "AWS", iconifyClass: "simple-icons:amazonaws" },
        { name: "Dapper", iconifyClass: "simple-icons:dapper" },
      ],
      link: "",
    },
  ],
};

// Publications
const publicationsHeader = {
  title: "Publications",
  description:
    "Some of my published Articles, Blogs and Research in software development and system design.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "Feel free to reach out to discuss .NET projects, API development, or system architecture. I’m always open to learning and collaborating on impactful solutions.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Navsari, Gujarat, India",
    locality: "Navsari",
    country: "India",
    region: "Gujarat",
    postalCode: "396445",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://tinyurl.com/44rwak44",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91-7285841578",
  },
  blogSection: {
    title: "Dipesh Chaudhari",
    subtitle: "Software Developer",
    link: "https://dipeshchaudhari3255.github.io/",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  achievementSection,
  experience,
  projectsHeader,
  projects,
  publicationsHeader,
  publications,
  contactPageData,
};
